/*
 * Copyright (c) 2024-2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {ProgramTimingRow} from './programTimingRow';
import {KtsTimingTemplateRow} from './ktsTimingTemplateRow.model';
import {ValidationModel} from './validation.model';

export class ProgramRun extends ValidationModel {
    id: number;
    momentumId: string;
    programName: string;
    templateVersion: string;
    type: string;
    gpsProjectId: string;
    gpsRpo: string;
    vehicleProjectClassification: string;
    archived: boolean;
    programTimingRows = [];
    icdStageDeliverables: string[] = [];
    icdStageLightingDeliverables: string[] = [];
    primaryProgram: boolean;
    createdDate: Date;
    createdBy: string;
    setProgramTimingRowsWithKtsTemplateRows(rowList: Array<KtsTimingTemplateRow>, gridProgramKey?: string) {
        // programName must be set before calling this
        if (!this.programName) {
            throw new Error('programName must be set before calling setProgramTimingRowsWithKtsTemplateRows');
        }
        const dataKey = gridProgramKey ?? this.programName;
        for (const row of rowList) {
            const programTimingRow = new ProgramTimingRow();
            programTimingRow.ktsTimingTemplateRow = structuredClone(row);
            // set the version back to the full version as we send it to the backend
            programTimingRow.ktsTimingTemplateRow.version = row.fullVersion;
            programTimingRow.date = structuredClone(row.programData.get(dataKey).date);
            programTimingRow.adjustedWeeks = row.programData.get(dataKey).adjustedWeeks;
            this.programTimingRows.push(programTimingRow);
        }
    }

    getKey(): string {
        if (this.type === 'ECS') {
            return `${this.gpsProjectId ?? ''}|${this.momentumId ?? ''}|${this.gpsRpo ?? ''}|${this.type}`;
        }
        return `${this.programName}|${this.type ?? ''}`;
    }

    setProgramRunFromEsciData(result) {
        this.id = result.id;
        this.momentumId = result.momentumId;
        this.programName = result.programName;
        this.templateVersion = result.templateVersion;
        this.type = result.type;
        this.gpsProjectId = result.gpsProjectId;
        this.gpsRpo = result.gpsRpo;
        this.vehicleProjectClassification = result.vehicleProjectClassification;
        this.archived = !!result.archived;
        this.createdDate = new Date(result.Created_Date);
        this.createdBy = result.Created_By;
        this.primaryProgram = result.primaryProgram;
        this.icdStageDeliverables = result.icdStageDeliverables || [];
        this.icdStageLightingDeliverables = result.icdStageLightingDeliverables || [];
        this.programTimingRows = [];
        if (result.programTimingRows) {
            for (const row of result.programTimingRows) {
                const programTimingRow = new ProgramTimingRow();
                programTimingRow.setProgramTimingRowFromEsciData(row);
                this.programTimingRows.push(programTimingRow);
            }
        }
    }
}
